module.exports = "https://static.wmbcdn.com/uniweb/images/ad6c4cbf1718e692c901166fac49962b.svg";